import { render, staticRenderFns } from "./InvoiceModelTypeView.vue?vue&type=template&id=2aa4a2b6&scoped=true&"
import script from "./InvoiceModelTypeView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceModelTypeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa4a2b6",
  null
  
)

export default component.exports